import React, { useEffect, useState } from "react";
import { ApiDataAccess } from "../../../common/ApiDataAccess";
import { Navigate, useNavigate } from "react-router-dom";
import { Logger } from "../../../../infrastructure/Logger";
import { TagsDisplayControl } from "./TagsDisplayControl";
import { Cache } from "../../../common/Cache";

export const TagsListControl = ({ tags, onTagClick, onTagRemoved }) => {
   
    return (
        <div className="tags-list-control">
            {tags && tags.length > 0 && (
                <TagsDisplayControl
                    tags={tags}
                    onTagClick={onTagClick}
                    onTagRemoved={onTagRemoved}
                />
            )}
        </div>
    );
};
